import { useEffect, useMemo, useRef } from 'react';

export function useRequestGuard() {
  const active = useRef(true);
  const request = useRef(0);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
      request.current += 1;
    };
  }, []);
  return useMemo(
    () => ({
      begin: () => ++request.current,
      current: token => active.current && token === request.current,
      mounted: () => active.current,
      invalidate: () => {
        request.current += 1;
      }
    }),
    []
  );
}

export function useRefreshOnVisible(refresh) {
  useEffect(() => {
    const visible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    document.addEventListener('visibilitychange', visible);
    return () => document.removeEventListener('visibilitychange', visible);
  }, [refresh]);
}
